
import vSelect from './vselect'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async swichTo () {
let temp = this.to
this.to = this.source
this.source = temp
temp = this.to_num
this.to_num = this.source_num
this.source_num = temp
},
async doQuery () {
if (this.source === '' || this.to === '') {
this.$vux.alert.show({
title: '注意',
content: '请选择单位'
})
return
}
if (this.source === this.to) {
this.$vux.alert.show({
title: '注意',
content: '要查询的单位与原单位相同，不需要转换'
})
return
}

if (this.source_num === '') {
this.$vux.alert.show({
title: '注意',
content: '请输入源单位参数的数值'
})
return
}
const queryPromise = await this.$http.get('/API/StatsParam/query'
, {params: {source: this.source, to: this.to, gname: this.g_name}})
this.result = queryPromise.data
if (!this.result) {
this.$vux.alert.show({
title: '注意',
content: '未找到对应的转换单位'
})
return
}
this.to_num = this.source_num / this.result.S_Number_Soruce * this.result.S_Number_To
this.to_num = this.to_num.toFixed(4)
},
getTextOfValue (val) {
if (val === '') {
return ''
}
return (this.paramList.filter(obj => {
return obj.ID === val
}))[0].P_NAME
},
async getParam () {
const queryPromise = await this.$http.get('/API/StatsParam/ParamByGroup'
, {params: {group: this.$route.query.code}})
return queryPromise.data
},
clear () {
this.source = ''
this.to = ''
this.source_num = ''
this.to_num = ''
}
},
data () {
return {
g_name: '',
source: '',
source_num: '',
src_paramList: [{P_NAME: '源单位', ID: ''}],
dst_paramList: [{P_NAME: '目标单位', ID: ''}],
g_nameList: [{G_NAME: '请选择'}],
to: '',
to_num: '',
result: ''
}
},
async activated () {
let paramList = (await this.getParam())
console.log(paramList)
const queryPromise1 = await this.$http.get('/API/StatsParam/GetNames'
, {params: {group: this.$route.query.code}})
console.log(queryPromise1.data)
this.g_nameList = this.g_nameList.concat(queryPromise1.data)
this.src_paramList = this.src_paramList.concat(paramList)
this.dst_paramList = this.dst_paramList.concat(paramList)
this.source = this.src_paramList[0].ID
this.to = this.dst_paramList[0].ID
}
}



// WEBPACK FOOTER //
// ./src/components/UnitConvertQuery.vue